export default __webpack_public_path__ + "assets/youtube-logo.439ef653.png";